import { z } from "zod";
import { i18nMessage } from "@/lib/i18nMessage";
import { PickupZone } from "../../api/api-types";

export const PickupZoneSchema = z.object({
  color: z
    .string({
      required_error: i18nMessage("boLogistics:zoneForm.colorRequired"),
    })
    .min(1, i18nMessage("boLogistics:zoneForm.colorRequired")),
  name: z
    .string({
      required_error: i18nMessage("boLogistics:zoneForm.nameRequired"),
    })
    .min(1, i18nMessage("boLogistics:zoneForm.nameRequired")),
  maxPickup: z
    .number({ message: i18nMessage("boLogistics:zoneForm.maxPickupRequired") })
    .min(1, i18nMessage("boLogistics:zoneForm.maxPickupRequired")),
  pickupDays: z
    .array(
      z.object({
        pickupDay: z.enum(["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY"], {
          message: i18nMessage("boLogistics:zoneForm.pickupDayRequired"),
        }),
        pickupTime: z.enum(["MORNING", "AFTERNOON", "ALLDAY"], {
          message: i18nMessage("boLogistics:zoneForm.pickupTimeRequired"),
        }),
      }),
    )
    .min(1, i18nMessage("boLogistics:zoneForm.pickupDaysMin")),
  remote: z.boolean(),
});

export type PickupZoneFormData = z.infer<typeof PickupZoneSchema>;

export const buildDefaultValues = (zone: PickupZone | null): PickupZoneFormData => ({
  color: zone?.color ?? "#0066FF",
  name: zone?.name ?? "",
  maxPickup: zone?.maxPickup ?? (undefined as unknown as number),
  remote: zone?.remote ?? false,
  pickupDays: (zone?.pickupDays.map(({ pickupDay, pickupTime }) => ({
    pickupDay,
    pickupTime,
  })) ?? []) as PickupZoneFormData["pickupDays"],
});
